import CryptoJS from 'crypto-js' // Ensure this is imported if not already

export function encrypt(data, stringify = true) {
    console.log('Encryption Identifier ', process.env.VUE_APP_IDENTIFIER)
    if (stringify) {
        data = JSON.stringify(data)
        console.log('Stringified data for encryption:', data)
    }
    let enc = this.CryptoJS.AES.encrypt(
        data,
        process.env.VUE_APP_CSK
    ).toString()

    return enc
}
export function decrypt(data) {
    let dec = this.CryptoJS.AES.decrypt(
        data,
        process.env.VUE_APP_CSK
    ).toString(CryptoJS.enc.Utf8)
    dec = JSON.parse(dec)

    return dec
}
